/* unplugin-vue-components disabled */import { render } from "./xradioButton.vue?vue&type=template&id=ddaaaa96"
import script from "./xradioButton.vue?vue&type=script&lang=js"
export * from "./xradioButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__